const ELYXConstants = {
  /** If you need super custom styles, just create a new 'customSomethingContainer' and
   * then create the appropriate v-if in the base modal, to ensure a scalable solution
   * that doesn't break anything.
   *
   * @NB Ensure to repeat same values everywhere; where there is no value, set it to null. */
  modals: {
    CalendarBookingLimitInfoModal: {
      name: "CalendarBookingLimitInfoModal",
      canCloseFromBackground: true,
      isInfoModal: true,
      location: "",
      heightBreakOff: 800,
      widthBreakOff: 800,
      styles: {
        base: {
          background: null,
        },
        container: {
          minWidth: null,
          blurStrength: null,
          backdropFilter: null,
          customBreakOffContainer: null,
        },
        blur: {
          blurIsActive: true,
          blurBackground: "unset",
        },
      },
    },
    CalendarBookingRestrictionModal: {
      name: "CalendarBookingRestrictionModal",
      canCloseFromBackground: false,
      location: "calendar",
      heightBreakOff: 405.5,
      widthBreakOff: 450,
      styles: {
        base: {
          background: null,
        },
        container: {
          minWidth: null,
          blurStrength: null,
          backdropFilter: null,
          customBreakOffContainer: null,
        },
        blur: {
          blurIsActive: null,
          blurBackground: null,
        },
      },
    },
    CalendarBookingFrozenModal: {
      name: "CalendarBookingFrozenModal",
      canCloseFromBackground: false,
      location: "calendar",
      heightBreakOff: 625,
      widthBreakOff: 450,
      styles: {
        base: {
          background: null,
        },
        container: {
          minWidth: null,
          blurStrength: null,
          backdropFilter: null,
          customBreakOffContainer: null,
        },
        blur: {
          blurIsActive: null,
          blurBackground: null,
        },
      },
    },
    CalendarRequestFailedModal: {
      name: "CalendarRequestFailedModal",
      canCloseFromBackground: false,
      location: "calendar",
      heightBreakOff: 289,
      widthBreakOff: 450,
      styles: {
        base: {
          background: null,
        },
        container: {
          minWidth: null,
          blurStrength: null,
          backdropFilter: null,
          customBreakOffContainer: null,
        },
        blur: {
          blurIsActive: null,
          blurBackground: null,
        },
      },
    },
    SubscriptionModal: {
      name: "SubscriptionModal",
      canCloseFromBackground: true,
      location: "",
      heightBreakOff: 795,
      widthBreakOff: 500,
      styles: {
        base: {
          background: "transparent",
        },
        container: {
          minWidth: 465,
          blurStrength: null,
          backdropFilter: "unset",
          customBreakOffContainer: `justify-content: center; border-radius: 0px;`,
        },
        blur: {
          blurIsActive: true,
          blurBackground: "unset",
        },
      },
    },
    SubscriptionModalSuccess: {
      name: "SubscriptionModalSuccess",
      canCloseFromBackground: false,
      location: "",
      heightBreakOff: 625,
      widthBreakOff: 500,
      styles: {
        base: {
          background: "transparent",
        },
        container: {
          minWidth: 465,
          blurStrength: null,
          backdropFilter: null,
          customBreakOffContainer: `justify-content: center; border-radius: 0px;`,
        },
        blur: {
          blurIsActive: true,
          blurBackground: "unset",
        },
      },
    },
    SubscriptionModalFail: {
      name: "SubscriptionModalFail",
      canCloseFromBackground: false,
      location: "",
      heightBreakOff: 300,
      widthBreakOff: 500,
      styles: {
        base: {
          background: "transparent",
        },
        container: {
          minWidth: 465,
          blurStrength: null,
          backdropFilter: null,
          customBreakOffContainer: null,
        },
        blur: {
          blurIsActive: true,
          blurBackground: "unset",
        },
      },
    },
    Settings: {
      name: "Settings",
      canCloseFromBackground: true,
      location: "",
      heightBreakOff: 865,
      widthBreakOff: 942,
      styles: {
        base: {
          background: "unset",
        },
        container: {
          minWidth: null,
          blurStrength: 50,
          backdropFilter: null,
          customBreakOffContainer: `width: 100%;`,
        },
        blur: {
          blurIsActive: true,
          blurBackground: "unset",
        },
      },
    },
    Tasks: {
      name: "Tasks",
      canCloseFromBackground: false,
      location: "",
      heightBreakOff: 865,
      widthBreakOff: 942,
      styles: {
        base: {
          background: "unset",
        },
        container: {
          minWidth: null,
          blurStrength: 50,
          backdropFilter: null,
          customBreakOffContainer: `width: 100%;`,
        },
        blur: {
          blurIsActive: true,
          blurBackground: "unset",
        },
      },
    },
    SubspaceModalDeletion: {
      name: "SubspaceModalDeletion",
      canCloseFromBackground: true,
      location: "",
      heightBreakOff: 865,
      widthBreakOff: 450,
      styles: {
        base: {
          background: "unset",
        },
        container: {
          minWidth: null,
          blurStrength: 50,
          backdropFilter: null,
          customBreakOffContainer: null,
        },
        blur: {
          blurIsActive: true,
          blurBackground: "unset",
        },
      },
    },
  },
};

export default ELYXConstants;
